// extracted by mini-css-extract-plugin
export default {"list-wrapper":"PreloaderSimilarCities_list-wrapper__u890w","block":"PreloaderSimilarCities_block__7lT+A"};